import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { FeeInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransferProvider } from '../providers/transfer-provider.service';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SetFeeUseCaseParams {
    data: FeeInterface;
}

@Injectable()
export class SetFeeUseCase implements UseCaseWithParam<SetFeeUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private contractProvider: ContractProvider, private transferProvider: TransferProvider) {}

    bind(params: SetFeeUseCaseParams): Observable<Transaction<boolean>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.transferProvider.setFee(contract.encryptedCode, params.data),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
